import React, { useEffect, useState } from "react";
import MasterLayout from "../Sections/MasterLayout";

const API = "https://rang-rasiya-backend.onrender.com/api/admin_link/bookings";

export default function AllBookings() {
  const [bookings, setBookings] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(false);

  // Fetch
  const fetchBookings = async () => {
    try {
      setLoading(true);
      const res = await fetch(API, { method: "POST" });
      const data = await res.json();
      setBookings(data.data || []);
      setFiltered(data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  // Search + Filter logic
  useEffect(() => {
    let result = bookings;

    if (filter !== "all") {
      result = result.filter((b) => b.passType === filter);
    }

    if (search) {
      result = result.filter(
        (b) =>
          b.name.toLowerCase().includes(search.toLowerCase()) ||
          b.bookingCode.toLowerCase().includes(search.toLowerCase()) ||
          b.whatsapp.includes(search)
      );
    }

    setFiltered(result);
  }, [search, filter, bookings]);

  return (
    <MasterLayout>
      <div className="bg-white p-6 rounded-lg shadow">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 mb-6">
          <h2 className="text-2xl font-bold">All Bookings</h2>

          <div className="flex gap-4">
            <input
              type="text"
              placeholder="Search name / code / phone"
              className="border px-4 py-2 rounded-lg"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <select
              className="border px-4 py-2 rounded-lg"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              <option value="all">All Passes</option>
              <option value="stag">Stag</option>
              <option value="couple">Couple</option>
              <option value="group">Group</option>
              <option value="kid">Kid</option>
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 text-left">Name</th>
                <th className="p-3 text-left">Phone</th>
                <th className="p-3 text-left">Pass</th>
                <th className="p-3 text-left">Code</th>
                <th className="p-3 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((b) => (
                <tr key={b._id} className="border-b hover:bg-gray-50">
                  <td className="p-3">{b.name}</td>
                  <td className="p-3">{b.whatsapp}</td>
                  <td className="p-3 capitalize">{b.passType}</td>
                  <td className="p-3 font-mono">{b.bookingCode}</td>
                  <td className="p-3">
                    {b.isCodeUsed ? (
                      <span className="text-green-600 font-semibold">
                        Checked-in
                      </span>
                    ) : (
                      <span className="text-red-500">Pending</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {filtered.length === 0 && (
            <div className="text-center py-10 text-gray-500">
              No bookings found
            </div>
          )}
        </div>
      </div>
    </MasterLayout>
  );
}